import React, { useEffect, useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import { IoIosSearch } from "react-icons/io";
import {
  apiMapping,
  headerOptions,
  ImageBaseUrl,
  inspectionType,
  selectField,
} from "../../utils/helperData";
import { useDispatch, useSelector } from "react-redux";
import { resetGlobalSearchState } from "../../../redux/reducer/GlobalSearchReducer/GlobalSearchReducer";
import Pagination from "../../customComponent/Pagination";
import {
  ADD_NEW_INSPECTION,
  ISO_WELD_LOG,
  WELDING_GAS_INSPECTION_FORM,
  WELDING_MACHINE_CALIBRATION,
  WELDING_WPQ_INSPECTION,
} from "../../utils/RouteConstant";
import { useNavigate } from "react-router";

const GlobalSearch = () => {
  const [selectedInspection, setSelectedInspection] = useState("");
  const [selectedField, setSelectedField] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 20, 50, 100, "All"];
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { globalSearchDetails, count } = useSelector(
    (state) => state.globalSearch
  );
  console.log("counting", count);
  const totalPages = rowsPerPage === "All" ? 1 : Math.ceil(count / rowsPerPage);

  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setRowsPerPage(count);
      setCurrentPage(1);
    } else {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };
  useEffect(() => {
    if (selectedInspection && selectedField) {
      const apiFunction = apiMapping[selectedInspection];
      if (apiFunction) {
        dispatch(
          apiFunction(currentPage, selectedField, rowsPerPage, searchTerm)
        );
      }
    }
  }, [
    dispatch,
    selectedInspection,
    selectedField,
    searchTerm,
    currentPage,
    rowsPerPage,
  ]);

  const handleInspectionChange = (event) => {
    const value = event.target.value;
    setSelectedInspection(value);
    setSelectedField("");
    setSearchTerm("");
    dispatch(resetGlobalSearchState());
  };

  const handleFieldChange = (event) => {
    const value = event.target.value;
    setSelectedField(value);
    setSearchTerm("");
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const currentHeaders = headerOptions[selectedInspection] || [];
  const tableData = Array.isArray(globalSearchDetails?.data)
    ? globalSearchDetails?.data
    : globalSearchDetails?.data?.data || [];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleRowClick = (verify) => {
    let route = "";
    switch (selectedInspection) {
      case "mi":
        route = ADD_NEW_INSPECTION;
        break;
      case "wgc":
        route = WELDING_GAS_INSPECTION_FORM;
        break;
      case "mac":
        route = WELDING_MACHINE_CALIBRATION;
        break;
      case "wowc":
        route = WELDING_WPQ_INSPECTION;
        break;
      case "iwl":
        route = ISO_WELD_LOG;
        break;
      default:
        return;
    }

    navigate(route, {
      state: {
        data: {
          _id: verify?._id,
          project_id: verify?.project_id,
          project_name: verify?.project_name,
        },
      },
    });
  };

  const baseUrl = ImageBaseUrl;

  const handleDownload = async (event, documents, item) => {
    console.log("globalSearchDetails", item);
    event.stopPropagation();
    event.preventDefault();

    // const fileName =
    //   item?.inspection_type?.id === "iwl" ? item?.iso_draw_no : item?.ref_no;
      const selectedInspectionType = inspectionType.find(
        (type) => type.id === selectedInspection
      );
      const fileName =
        selectedInspectionType?.id === "iwl" ? item?.iso_draw_no : item?.ref_no;

    for (const docUrl of documents) {
      console.log("docUrl", docUrl);
      try {
        const response = await fetch(`${baseUrl}/${docUrl}`);

        if (!response.ok) {
          throw new Error(`Failed to fetch file: ${response.statusText}`);
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        // link.download = `${ref_no}.pdf`;
        link.download = `${fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        console.error("Download failed:", error);
      }
    }
  };

  const hasDocuments = tableData?.some(
    (item) => Array.isArray(item?.document) && item.document.length > 0
  );
  return (
    <div>
      <h2 className="text-3xl font-bold mb-10">Global Search</h2>
      <div className="flex flex-col sm:flex-row items-center gap-20">
        <FormControl className="w-full md:w-auto flex-1 max-w-md">
          <InputLabel id="inspection-type-label">Inspection Type</InputLabel>
          <Select
            labelId="inspection-type-label"
            id="inspection-type"
            label="Inspection Type"
            value={selectedInspection}
            onChange={handleInspectionChange}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                  overflowY: "auto",
                },
              },
            }}
          >
            <MenuItem value="" disabled>
              <em>Select Inspection Type</em>
            </MenuItem>
            {inspectionType.map((inspection) => (
              <MenuItem key={inspection.id} value={inspection.id}>
                {inspection.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedInspection && (
          <FormControl
            className="w-full md:w-auto flex-1 max-w-md"
            disabled={!selectedInspection}
          >
            <InputLabel id="field-label">Select Field</InputLabel>
            <Select
              labelId="field-label"
              id="field-select"
              label="Select Field"
              value={selectedField}
              onChange={handleFieldChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    overflowY: "auto",
                  },
                },
              }}
            >
              <MenuItem value="" disabled>
                <em>Select Field</em>
              </MenuItem>
              {selectField[selectedInspection]?.map((field) => (
                <MenuItem key={field.id} value={field.id}>
                  {field.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {selectedField && (
          <div className="relative flex-1 min-w-[250px] max-w-full">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search"
              className="w-full pl-10 pr-4 py-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm"
            />
            <IoIosSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg" />
          </div>
        )}
      </div>

      {searchTerm && tableData.length > 0 && (
        <div className="mt-10 overflow-x-auto">
          <table className="table-auto w-full border-collapse border border-gray-400">
            <thead>
              <tr>
                {currentHeaders?.map((header, index) => (
                  <th
                    key={index}
                    className="py-2 px-1 bg-gray-300 font-medium text-gray-600 text-sm md:text-base"
                    style={{ maxWidth: "110px" }}
                  >
                    <div className="flex items-center">
                      <span
                        className={
                          header.label.length > 12
                            ? "block"
                            : "whitespace-nowrap"
                        }
                      >
                        {header.label}
                      </span>
                    </div>
                  </th>
                ))}
                {hasDocuments && (
                  <th className="py-2 px-1 bg-gray-300 font-medium text-gray-600 text-sm md:text-base">
                    Action
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {tableData?.map((item, rowIndex) => (
                <tr
                  key={rowIndex}
                  onClick={() => handleRowClick(item)}
                  className="text-sm text-[#626262] font-light cursor-pointer"
                >
                  {currentHeaders?.map((header, colIndex) => (
                    <td
                      key={colIndex}
                      className="px-4 py-3 whitespace-nowrap text-sm font-medium relative"
                    >
                      {header?.field === "createdAt" ||
                      header?.field === "ins_date" ? (
                        formatDate(item[header?.field])
                      ) : header?.field === "ref_no" ? (
                        <span
                          title={item[header?.field]}
                          className="truncate max-w-[110px] block"
                        >
                          {item[header?.field]?.slice(0, 10)}
                          {item[header?.field]?.length > 10 ? "..." : ""}
                        </span>
                      ) : header?.field ? (
                        typeof item[header?.field] === "object" ? (
                          item[header?.field]?.name || "-"
                        ) : (
                          item[header?.field]
                        )
                      ) : (
                        "-"
                      )}
                    </td>
                  ))}
                  {hasDocuments && (
                    <td className="px-4 py-3 text-center">
                      {Array.isArray(item?.document) &&
                      item.document.length > 0 ? (
                        <button
                          onClick={(e) =>
                            handleDownload(e, item.document, item)
                          }
                          className="text-blue-500 hover:underline"
                        >
                          📥
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {searchTerm && tableData?.length === 0 && (
        <div className="mt-10 text-gray-500 text-center">
          No data available for the selected filters.
        </div>
      )}

      {searchTerm && (
        <div className="flex items-center justify-end mb-4 space-x-3">
          <div className="flex items-center mt-6 ">
            <label htmlFor="rows-per-page" className="mr-2">
              Rows per page:
            </label>
            <select
              id="rows-per-page"
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          {totalPages > 1 && rowsPerPage !== "All" && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default GlobalSearch;
